import styles from "../assets/sass/NotFound.module.sass";
import { usePageTitle } from "../utils/usePageTitle";

export default function NotFound(props) {
  usePageTitle(props?.pageTitle || "Page not found.");

  return (
    <div className={styles.container}>
      <h1 className={styles.message}>{props?.message || "Page not found."}</h1>
    </div>
  );
}
